<template>
    <div class="panels" v-show="!isLoading">
        <LeftMenu
            :entityParent="entityParent"
            :entityType="entityType"
            :displayed="displayed"
            :activeTab="activeTab"
            :id="id"
            :name="name"
            :adress="adress"
            :comment="comment"
            :idParent="idParent"
            :isLoading="isLoading"
            @updateActiveTab="displayTab"
            @editAction="editAction"
        />

        <div class="content-panel">
            <!-- DETAILS -->
            <v3-warning
                v-if="activeTab === 'authorizations' || activeTab === 'codes'"
            />
            <Home
                v-show="activeTab === 'details'"
                :apartments="apartments"
                :activeTab="activeTab"
                :entityParent="entityParent"
                :path="path"
                :idParent="idParent"
                :id="id"
                :name="name"
                :comment="comment"
                :countAccess="countAccess"
                :adress="adress"
                :type="type"
                :accesses="accesses"
                :intercoms="intercoms"
                @showMore="showMore"
            />

            <!-- AUTHORIZATIONS -->
            <div
                id="v1-auths-bloc"
                class="tab-panel"
                v-show="activeTab === 'authorizations'"
            >
                <loader class="v1-tab-loader"></loader>
            </div>

            <!-- CODES -->
            <div class="tab-panel" v-if="activeTab === 'codes'">
                <CodeByAccessView
                    :residenceId="path.residence.id"
                    residencePart="Stairwell"
                />
            </div>

            <!-- CENTRAL UNITS -->
            <div class="tab-panel" v-show="activeTab === 'central-units'">
                <centralUnitsList
                    :idResidence="centralUnitsParam"
                    :activeTab="activeTab"
                >
                </centralUnitsList>
            </div>
            <!-- SUBACCOUNTS -->
            <div class="tab-panel" v-show="activeTab === 'subaccounts'">
                <subaccounts-list
                    :subaccounts="subaccounts"
                    :agences="agences"
                ></subaccounts-list>
            </div>
        </div>
    </div>
    <div v-show="isLoading" class="panels-loading">
        <Loader />
    </div>
</template>

<script>
import httpIntratone from "@/services/httpIntratone.js"

import { getStairwellSummaryById } from "@/services/intratone/stairwell.js"
import { getResidenceSubaccountsById } from "@/services/intratone/residence.js"

import Loader from "@/components/basic/Loader.vue"
import Home from "@/views/stairwell/Home.vue"
import LeftMenu from "@/views/stairwell/LeftMenu.vue"
import centralUnitsList from "@/components/entities/CentralUnitsList.vue"
import SubaccountsList from "@/components/entities/SubaccountsList.vue"

import v1mixin from "@/mixins/v1.js"
import { entityType } from "@/enums"

import { useToast } from "vue-toastification"
import { getAccess } from "@/services/intratone/access"

import V3Warning from "@/components/V3Warning"
import CodeByAccessView from "../codeByAccess/CodeByAccessView.vue"

const toast = useToast()

export default {
    name: "StairwellDetails",
    components: {
        LeftMenu,
        Loader,
        V3Warning,
        centralUnitsList,
        SubaccountsList,
        Home,
        CodeByAccessView,
    },
    mixins: [v1mixin],
    data() {
        return {
            isLoading: true,
            // Parent type and data
            entityParent: null,
            idParent: null,
            // Entity path
            path: null,
            //Useful for displayTab Cenunit
            centralUnitsParam: "0",
            // Entity type and data
            entity: entityType.STAIRWELL,
            id: null,
            name: null,
            comment: null,
            adress: null,
            type: null,
            displayed: false,
            // Accesses
            accesses: [],
            // Apartments
            apartments: [],
            // Intercoms
            intercoms: [],
            // Active tab
            activeTab: "details",
            // Show all accesses
            showAllAccesses: false,
            // Types of entity
            entityType,
            accessPage: 1,
            accessTotalPage: 1,
            countAccess: 0,
            subaccounts: [],
            agences: [],
            //Display
            authorizationsDisplayed: false,
            codesDisplayed: false,

            baseUrlImprim: process.env.VUE_APP_PHP_SITE_URL,
        }
    },
    computed: {
        allStairwells() {
            return this.buildings.concat(this.stairwells)
        },
        tabParameter() {
            return this.$route.params.tab !== ""
                ? this.$route.params.tab
                : "details"
        },
    },
    watch: {
        tabParameter() {
            if (this.$route.name === "Stairwell") {
                this.displayTab(this.tabParameter)
            }
        },
    },
    methods: {
        showMore() {
            getAccess({
                idcag: this.id,
                for: "linked",
                limit: this.countAccess,
                stat: "cles",
            }).then((response) => {
                response.data.list.forEach((newAccess) => {
                    if (
                        this.accesses.find(
                            (exist) => exist.id === newAccess.id
                        ) === undefined
                    ) {
                        this.accesses.push(newAccess)
                    }
                })
                this.accessPage = parseInt(response.data._page)
                this.accessTotalPage = parseInt(response.data._pages)
            })
        },
        createAction() {
            this.openV1Modal("data/batiment_add", "Act_Zone")
        },

        editAction(value) {
            if (value === 1) {
                this.goToV1View("data/cage/cage/edit=1&type=CAGE&id=" + this.id)
            } else {
                this.goToV1View(
                    "data/residence/load/edit=1&id=" + this.path.residence.id
                )
            }
        },
        getPathAppart(key) {
            if (key === "batiment") {
                return "/building/"
            } else {
                return "/residence/"
            }
        },
        async load() {
            this.activeTab = "details"
            this.isLoading = true
            this.entityParent = null
            this.path = null
            this.idParent = null
            this.id = null
            this.name = null
            this.comment = null
            this.adress = null
            this.type = null
            this.accesses = []
            this.apartments = []
            this.intercoms = []

            await this.loadStairwell()
            if (this.tabParameter === "" || this.tabParameter === undefined) {
                this.displayTab("details")
            } else {
                this.displayTab(this.tabParameter)
            }
        },
        async loadStairwell() {
            try {
                // V1 site request in order to set v1 site session with stairwell
                let v1Call = await httpIntratone.post(
                    "data/cage/cage.php",
                    `id=${this.$route.params.id}&SID=${this.$store.getters["auth/getIntratoneDev2SID"]}`
                )
                // Getting stairwell
                let stairwellResponse = await getStairwellSummaryById(
                    this.$route.params.id
                )
                if (stairwellResponse === null) {
                    throw new Error()
                }
                if (stairwellResponse.state === "error") {
                    if (stairwellResponse.code === "API_RESTRICTED") {
                        this.$router.push({
                            path: "/error/401",
                        })
                    } else {
                        this.$router.push({
                            path: "/error/404",
                        })
                    }
                    return
                }
                // Stairwell data)
                this.id = stairwellResponse.data.cage.id
                this.name = stairwellResponse.data.cage.nom
                this.comment = stairwellResponse.data.cage.comments
                this.adress = stairwellResponse.data.cage.adr
                this.path = stairwellResponse.data.path
                this.$store.commit(
                    "account/setApartmentsCount",
                    stairwellResponse.data.apparts._count
                )

                if (stairwellResponse.data.cage.pere !== "0") {
                    this.entityParent = entityType.BUILDING
                    this.idParent = stairwellResponse.data.cage.pere
                    this.$store.commit(
                        "account/setStairwellId",
                        parseInt(this.id)
                    )
                } else {
                    this.entityParent = entityType.RESIDENCE
                    this.idParent = stairwellResponse.data.cage.idres
                    this.$store.commit(
                        "account/setStairwellId",
                        parseInt(this.id)
                    )
                    this.$store.commit("account/setBuildingId", null)
                }

                // Accesses
                if (stairwellResponse.data.acces) {
                    this.accesses = stairwellResponse.data.acces.list.splice(
                        0,
                        8
                    )
                    this.countAccess = stairwellResponse.data.acces._count
                }
                stairwellResponse.data.acces.list.forEach((element) => {
                    if (element.plat === "1") {
                        this.intercoms.push(element.nom)
                    }
                })
                this.displayed = stairwellResponse.data.cage.cage_linked
                    ? true
                    : false

                // Apartments
                this.apartments = stairwellResponse.data.apparts

                const dataFilters = {
                    stairwell_res_id: stairwellResponse.data.path.residence.id,
                    stairwell_type: stairwellResponse.data.cage.type,
                    stairwell_pere: stairwellResponse.data.cage.pere,
                    stairwell_nom: stairwellResponse.data.cage.nom,
                    stairwell_cnil: stairwellResponse.data.cage.cnil,
                    staiwell_path: stairwellResponse.data.path,
                }

                // Stop loading
                this.isLoading = false
            } catch (error) {
                console.log(error)
            }
        },
        displayTab(tabLabel) {
            this.activeTab = tabLabel
            if (tabLabel === "central-units") {
                this.centralUnitsParam = this.path.residence.id
            }
            if (
                tabLabel === "authorizations" &&
                this.authorizationsDisplayed === false
            ) {
                this.openV1Modal(
                    "data/autorisation/autos/hide_bar=1&res=" +
                        this.path.residence.id,
                    "v1-auths-bloc"
                )
                this.authorizationsDisplayed = true
            }
            if (tabLabel === "codes" && this.codesDisplayed === false) {
                this.openV1Modal(
                    "data/codes/code_acces/hide_bar=1&res=" +
                        this.path.residence.id,
                    "v1-codes-bloc"
                )
                this.codesDisplayed = true
            }
            if (this.activeTab === "subaccounts") {
                this.loadSubaccounts()
            }
        },

        async loadSubaccounts() {
            try {
                let subaccountsResponse = await getResidenceSubaccountsById(
                    this.path.residence.id
                )
                if (subaccountsResponse === null) {
                    throw new Error()
                }
                this.subaccounts = subaccountsResponse.data.subaccounts
                this.agences = subaccountsResponse.data.agences
            } catch (error) {
                console.log(error)
            }
        },
    },
    created() {
        this.load()
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";
@import "@/assets/scss/details.scss";
@import "@/assets/scss/variables/fontSize.scss";

#v1-auths-bloc :deep() {
    @import "./../../assets/scss/v1-scss/style.scss";
    @import "./../../assets/scss/v1-scss/datepicker.scss";
    @import "./../../assets/scss/v1-scss/cle.scss";
    @import "./../../assets/scss/v1-scss/bootstrap/css/bootstrap.scss";
    @import "./../../assets/scss/v1-scss/bootstrap/css/bootstrap.min.scss";
    text-align: center;
}

@media all and (min-width: 1024px) {
    .no-mobile {
        display: none;
    }
}

@media all and (max-width: 1024px) {
    .mobile {
        display: none;
    }
}

.v1-tab-loader {
    margin-top: 25%;
}

.main-container {
    display: flex;
    width: 100%;
    height: 100%;
}

.tab-panel {
    width: 100%;
    height: 100%;
}
</style>
